<form class="flex flex-col w-full p-2" [formGroup]="dossierInterventionForm" (ngSubmit)="onFormSubmit()">
    <div class="grid grid-cols-2 gap-4">
        <div>
            <mat-form-field class="w-full">
                <mat-label>Numéro de dossier</mat-label>
                <input type="text" matInput formControlName="no_dossier">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full">
                <mat-label>Compagnie d'assurance</mat-label>
                <input type="text" matInput formControlName="compagnie_assurance">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full">
                <mat-label>Expert en sinitre</mat-label>
                <input type="text" matInput formControlName="expert_name">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full">
                <mat-label>Date de la perte</mat-label>
                <input type="date" matInput formControlName="date_perte">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full">
                <mat-label>Nom de l'assuré</mat-label>
                <input type="text" matInput formControlName="nom_assure">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full">
                <mat-label>Personne contact</mat-label>
                <input type="text" matInput formControlName="personne_contact">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full">
                <mat-label>Adresse de la propriété endommagée</mat-label>
                <input type="text" matInput formControlName="adresse_propriete_endommagee">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full">
                <mat-label>Téléphone 1</mat-label>
                <input type="text" matInput formControlName="phone1">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full">
                <mat-label>Mandat</mat-label>
                <mat-select matSelect formControlName="mandat" multiple>
                    <mat-option value="urgence">
                        Urgence
                    </mat-option>
                    <mat-option value="contenu">
                        Contenu
                    </mat-option>
                    <mat-option value="construction">
                        Construction
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full">
                <mat-label>Téléphone 2</mat-label>
                <input type="text" matInput formControlName="phone2">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full col-start-2">
                <mat-label>Adresse courriel</mat-label>
                <input type="email" matInput formControlName="email">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full col-span-2">
                <mat-label>Commentaires</mat-label>
                <textarea matInput formControlName="commentaires">
            </textarea>
            </mat-form-field>
        </div>
        <div class="col-span-2">
            <mat-form-field class="w-full">
                <mat-label>Techniciens</mat-label>
                <mat-select matSelect formControlName="users_id" multiple>
                    <mat-option class="select-all-checkbox">
                        <mat-checkbox
                            [(ngModel)]="areAllTechnicienSelected"
                            [ngModelOptions]="{standalone: true}"
                            [indeterminate]="isIndeterminate()"
                            (change)="toggleSelectAll($event)"
                        >
                            {{ areAllTechnicienSelected ? "Tout déselectionner" : "Tout sélectionner" }}
                        </mat-checkbox>
                    </mat-option>

                    <mat-option *ngFor="let user of users" [value]="user.id">
                        {{ user.prenom }} {{ user.nom }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="flex items-center justify-between w-full border-t px-8 py-4">
        <button *ngIf="currentDossierIntervention.id !== 0 && isAdmin" type="button" (click)="delete(currentDossierIntervention.id)" class="-ml-4" mat-button [color]="'warn'">
            Supprimer
        </button>
        <div class="flex items-center">
            <div class="flex items-center mr-4">
                <ng-container *ngIf="success">
                    <mat-icon class="text-green-500" [svgIcon]="'heroicons_outline:check'"></mat-icon>
                    <span class="ml-2">Le dossier d'intervention a été mis à jour</span>
                </ng-container>
                <ng-container *ngIf="error">
                    <mat-icon class="text-red-500" [svgIcon]="'heroicons_outline:x'"></mat-icon>
                    <span class="ml-2">Erreur lors de l'enregistrement, réessayez!</span>
                </ng-container>
                <ng-container *ngIf="noDossierDejaUtiliser">
                    <mat-icon class="text-red-500" [svgIcon]="'heroicons_outline:x'"></mat-icon>
                    <span class="ml-2">Le numéro de dossier est déjà utilisé</span>
                </ng-container>
            </div>
            <button type="submit" mat-flat-button [color]="'primary'">
                Enregistrer
            </button>
        </div>
    </div>
</form>
